export const restrictToRange = (value: number, min = 10, max = 90): number => {
  if (value < min) return min
  if (value > max) return max
  return value
}
